import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';
import useProject from './useProject';

export const useGenerateUnsavedViewId = () => {
  const { user } = useCurrentUserContext();
  const { data: project } = useProject();

  if (!user || !project) return null;

  return `${user.userName}-unsaved-${project.projectId}`;
};
